exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".userinfo-container .row {\n  margin-bottom: 30px;\n}\n.userinfo-container .row .token {\n  margin-right: 20px;\n}\n.userinfo-container .row .ant-btn {\n  margin-right: 15px;\n}\n", ""]);

// exports
